import { createSelector } from 'reselect';
import { initialState } from './grouplist.reducers';
import { EGroupStateKeys } from '../../domain/group.interface';

const selectGroup = (state: any) => state.groupListReducer || initialState;

const makeSelectGroupList = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupList],
  );

const makeSelectGroupComplete = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupComplete],
  );

const makeSelectGroupInfo = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupInfo],
  );

const makeSelectGroupMembers = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupMembers],
  );

const makeSelectGroupWishes = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupWishes],
  );

const makeSelectGroupMoneybox = () =>
  createSelector(
    selectGroup,
    groupState => groupState[EGroupStateKeys.groupMoneybox],
  );

export {
  makeSelectGroupList,
  makeSelectGroupComplete,
  makeSelectGroupInfo,
  makeSelectGroupMembers,
  makeSelectGroupWishes,
  makeSelectGroupMoneybox,
};
